export class ErrorLog {
    public errorType       :string
    public timeStamp       :string
    public requestUrl      :string
    public code            :string
    public stack           :string
    public responseStatus  :string
    public responseData    :string
    public responseHeaders :string
    public request         :string
    public config          :string
    public functionNm      :string
    public empCd           :string
    public message         :string
}
